export default "__VITE_ASSET__C8STlZ3K__"